import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from './theme';

interface OrderProps {
  count: number;
}

export const Order: FunctionComponent<OrderProps> = ({ count }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={{
        xs: 32,
        sm: 40,
      }}
      height={{
        xs: 32,
        sm: 40,
      }}
      style={{
        background: theme.palette.primary.light,
        borderRadius: '50%',
      }}
    >
      <Typography
        variant="body1"
        style={{
          color: theme.palette.primary.main,
          fontWeight: 600,
          fontSize: 24,
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};
